"use client";

import type { PaymentMode } from "@golf-district/service";
import { createContext, useContext, useEffect, useMemo, useRef } from "react";
import { api } from "~/utils/api";

function _ct(): string {
  if (typeof window === 'undefined') return '?ms';
  const t0 = (window as any).__checkoutT0 as number | undefined;
  return t0 !== undefined ? `+${(performance.now() - t0).toFixed(0)}ms` : 'no-t0';
}

interface PaymentModeContextValue {
    paymentModes: PaymentMode[];
    isLoading: boolean;
}

const PaymentModeContext = createContext<PaymentModeContextValue | null>(null);

export const PaymentModeWrapper = ({ children }: { children: React.ReactNode }) => {
    const fetchT0 = useRef<number>(performance.now());
    const { data, isLoading } = api.searchRouter.getPaymentModes.useQuery({});
    const paymentModes = useMemo(() => {
        if (!data) return [];
        return data;
    }, [data]);

    useEffect(() => {
        if (data?.length) {
            const took = (performance.now() - fetchT0.current).toFixed(0);
            console.log(`[CHECKOUT:CTX]  PaymentModes resolved | took=${took}ms | count=${data.length} | modes=${data.map(m => m.name).join(', ')} | ${_ct()}`);
        }
    }, [!!data]);

    const value = useMemo(
        () => ({
            paymentModes,
            isLoading,
        }),
        [paymentModes, isLoading]
    );
    return (
        <PaymentModeContext.Provider value={value}>
            {children}
        </PaymentModeContext.Provider>
    );
};

export const usePaymentMode = (): PaymentModeContextValue => {
    const ctx = useContext(PaymentModeContext);
    if (!ctx) {
        throw new Error("usePaymentMode must be used within PaymentModeWrapper");
    }
    return ctx;
};
